import PageContainer from '../components/layout/PageContainer'
import SettingsProfileForm from '../components/settings/SettingsProfileForm'
import SettingsSecurityForm from '../components/settings/SettingsSecurityForm'
// import SettingsNotificationPreferences from '../components/settings/SettingsNotificationPreferences'
import { useSettings } from '../hooks/useSettings'

const Settings = () => {
  const {
    user,
    notificationPrefs,
    setNotificationPrefs,
    isChangingPassword,
    isSavingProfile,
    updateProfile,
    saveNotificationPreferences,
    changePassword,
  } = useSettings()

  return (
    <PageContainer title="Settings" subtitle="Manage your account and preferences">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <SettingsProfileForm user={user} onSave={updateProfile} isSaving={isSavingProfile} />
        <SettingsSecurityForm onChangePassword={changePassword} isChanging={isChangingPassword} />
      </div>

      {/* <SettingsNotificationPreferences
        preferences={notificationPrefs}
        onPreferenceChange={setNotificationPrefs}
        onSave={saveNotificationPreferences}
        isSaving={isSavingProfile}
      /> */}
    </PageContainer>
  )
}

export default Settings
